import { type ThunkAction } from 'redux-thunk';
import { type ActionType } from 'typesafe-actions';

import { RequestStatus } from '../../../../models';
import * as api from '../api';
import type RootState from '../RootState';

import * as actions from './actions';

type Actions = ActionType<typeof actions>;
type ShortcutsThunkAction = ThunkAction<void, RootState, unknown, Actions>;

// eslint-disable-next-line import/prefer-default-export -- follow nav thunks file pattern
export const requestPersonalShortcuts =
  (): ShortcutsThunkAction => async (dispatch, getState) => {
    if (
      getState().shortcuts.personalShortcutsStatus === RequestStatus.Pending
    ) {
      return;
    }

    dispatch(actions.personalShortcutsRequested());

    try {
      const shortcuts = await api.readPersonalShortcuts();

      dispatch(actions.personalShortcutsReceived(shortcuts));
    } catch {
      dispatch(actions.personalShortcutsNotReceived());
    }
  };
